@layer app {
  .container {
    display: flex;
    flex-direction: column;
    min-height: 100dvh;
    container-type: inline-size;
    container-name: page;
  }
}
